/**
 * 로그인 토큰 — localStorage. 사생활 모드 등에서 저장소가 막히면 메모리에만 둔다.
 * 다른 프로젝트(project 6010)와 출처가 달라 토큰이 섞이지 않는다.
 */
const KEY = 'investment.accessToken';
let memory: string | null = null;

export const token = {
  get(): string | null {
    try { return localStorage.getItem(KEY) ?? memory; } catch { return memory; }
  },
  set(v: string) {
    memory = v;
    try { localStorage.setItem(KEY, v); } catch { /* 메모리만 */ }
  },
  clear() {
    memory = null;
    try { localStorage.removeItem(KEY); } catch { /* 없음 */ }
  },
};
